import { render } from "./search2map.vue?vue&type=template&id=2b230018"
import script from "./search2map.vue?vue&type=script&lang=js"
export * from "./search2map.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__